import { useQuery } from "@tanstack/react-query";
import { TanstackQueryKey } from "apps/commons/tanstackQueryKey";
import { oneOnboardingApi } from "libs/api";
import { useParams } from "router";

export const useBatchProfileDataApi = () => {
    const { lang } = useParams("/:lang/list-my-property/onboard/batch/profile");

    const { data, isLoading, isError, isFetching } = useQuery({
        queryKey: [TanstackQueryKey.GetBatchProfileData, lang],
        queryFn: () => oneOnboardingApi.getBulkOnboardingProfileData(lang).then((res) => res.data),
        staleTime: 0,
    });

    return {
        data,
        isLoading: isLoading || isFetching,
        isError,
    };
};
